export default __webpack_public_path__ + "static/media/sand1.bbdf9129.png";